var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer-legal", class: { "footer-legal--dark": _vm.dark } },
    [
      _c(
        "a",
        {
          attrs: {
            href: _vm.GENERAL_TERMS_LINK + "?lang=" + _vm.lang,
            target: "_blank",
            rel: "noopener",
          },
        },
        [_vm._v(_vm._s(_vm.$t("links.generalTerms")))]
      ),
      _vm._v(" "),
      _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("·")]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: _vm.PRIVACY_POLICY_LINK + "?lang=" + _vm.lang,
            target: "_blank",
            rel: "noopener",
          },
        },
        [_vm._v(_vm._s(_vm.$t("links.privacyPolicy")))]
      ),
      _vm._v(" "),
      _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("·")]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: _vm.LEGAL_NOTICE_LINK + "?lang=" + _vm.lang,
            target: "_blank",
            rel: "noopener",
          },
        },
        [_vm._v(_vm._s(_vm.$t("links.legal")))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }